import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * /assessments — list of all quizzes (practice / passing / blocking). Row
 * click → /assessments/:id. Create still a drawer (form until first save);
 * on save we navigate to the new page.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Empty, Popconfirm, Space, Table, Tag, Typography } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { deleteAssessment, listAssessments } from '../../api';
import { PageHeader } from '../../components/PageHeader';
import { notifySuccess } from '../../components/errors';
import { ContentTreeProvider } from '../../components/entityPickers';
import { AssessmentEditorDrawer, AssessmentLinkageSummary, } from '../../components/assessments/AssessmentEditorDrawer';
export default function AssessmentsListScreen() {
    const nav = useNavigate();
    const [assessments, setAssessments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [createOpen, setCreateOpen] = useState(false);
    const reloadList = useCallback(async () => {
        setLoading(true);
        try {
            setAssessments(await listAssessments());
        }
        catch { /* client auto-surfaces */ }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { void reloadList(); }, [reloadList]);
    const del = async (a) => {
        try {
            await deleteAssessment(a.id);
            notifySuccess('בוחן נמחק');
            reloadList();
        }
        catch { /* client auto-surfaces */ }
    };
    const cols = [
        { title: '#', dataIndex: 'id', width: 60 },
        { title: 'שם', dataIndex: 'name', render: (v) => v ?? _jsx(Typography.Text, { type: "secondary", children: "\u2014 \u05DC\u05DC\u05D0 \u05E9\u05DD \u2014" }) },
        { title: 'סוג', dataIndex: 'kind', width: 100, render: (v) => _jsx(Tag, { color: v === 'blocking' ? 'red' : v === 'passing' ? 'blue' : undefined, children: v }) },
        { title: 'הצמדה', render: (_, a) => _jsx(AssessmentLinkageSummary, { assessment: a }) },
        {
            title: 'פעולות', key: '__actions', width: 130, fixed: 'right',
            render: (_, a) => (_jsxs(Space, { size: 4, children: [_jsx(Button, { size: "small", icon: _jsx(EditOutlined, {}), onClick: (e) => { e.stopPropagation(); nav(`/assessments/${a.id}`); } }), _jsx(Popconfirm, { title: "\u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D1\u05D5\u05D7\u05DF?", okText: "\u05DE\u05D7\u05E7", cancelText: "\u05D1\u05D8\u05DC", onConfirm: () => del(a), children: _jsx(Button, { size: "small", danger: true, icon: _jsx(DeleteOutlined, {}), onClick: (e) => e.stopPropagation() }) })] })),
        },
    ];
    return (_jsxs(ContentTreeProvider, { children: [_jsx(PageHeader, { title: "\u05D1\u05D7\u05E0\u05D9\u05DD", breadcrumb: [{ label: 'ניהול' }, 'בחנים'], actions: _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => setCreateOpen(true), children: "\u05D1\u05D5\u05D7\u05DF \u05D7\u05D3\u05E9" }) }), _jsx(Card, { children: assessments.length === 0 && !loading
                    ? (_jsx(Empty, { description: "\u05D0\u05D9\u05DF \u05E2\u05D3\u05D9\u05D9\u05DF \u05D1\u05D7\u05E0\u05D9\u05DD", image: Empty.PRESENTED_IMAGE_SIMPLE, children: _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => setCreateOpen(true), children: "\u05D1\u05D5\u05D7\u05DF \u05D7\u05D3\u05E9" }) }))
                    : (_jsx(Table, { size: "small", rowKey: "id", pagination: false, loading: loading, dataSource: assessments, columns: cols, onRow: (r) => ({
                            onClick: () => nav(`/assessments/${r.id}`),
                            style: { cursor: 'pointer' },
                        }) })) }), createOpen && (_jsx(AssessmentEditorDrawer, { mode: "create", open: true, onClose: () => setCreateOpen(false), onSaved: (id) => { setCreateOpen(false); nav(`/assessments/${id}`); } }))] }));
}
